import './TurboTaxText.scss';

import React from 'react';

import { contentConverter } from 'services/Content';

function TurboTaxText({ className = 'text-content', content, children }) {
  return (
    <div>
      <div
        className={className}
        dangerouslySetInnerHTML={{ __html: contentConverter.makeHtml(content) }}
      />
      {children && <div className={`${className}-children`}>{children}</div>}
    </div>
  );
}

export default TurboTaxText;
